import MarketingPageWrapper from '@/domain/Training/MarketingPageWrapper';
import MarketingHero from '@/domain/Training/MarketingHero';
import MarketingHighlightCopy from '@/domain/Training/MarketingHighlightCopy';
import MarketingContent from '@/domain/Training/MarketingContent';
import MarketingTrainers from '@/domain/Training/MarketingTrainers';
import MarketingFeatures from '@/domain/Training/MarketingFeatures';
import MarketingProgramSimple from '@/domain/Training/MarketingProgramSimple';
import MarketingTestimonials from '@/domain/Training/MarketingTestimonials';
import MarketingFAQs from '@/domain/Training/MarketingFAQs';
import MarketingContact from '@/domain/Training/MarketingContact';
import client from '@/api/client';
import { trainingQuery } from '@/api/queries';

export async function getStaticProps() {
  const { data } = await client().query({
    query: trainingQuery,
    variables: {
      id: 'official-product-backlog-management-certification-training',
    },
  });

  return {
    props: {
      training: data?.training,
    },
  };
}

export default function TrainingMarketingPage({ training }) {
  const hasContent = training.content !== null;
  const hasTrainers = training.details.trainers !== null;
  const hasWhatIsLearned = training.details.whatIsLearned !== null;
  const hasProgramSubjects = training.details.programSubjects !== null;
  const hasTestimonials = training.details.testimonials !== null;
  const hasFAQs = training.details.faqs !== null;

  return (
    <MarketingPageWrapper>
      <MarketingHero
        heroCopy="Product Backlog Management"
        heroLead={
          <p className="leading-relaxed">
            El programa de entrenamiento&nbsp;
            <strong className="text-gray-900">
              más completo para hispanohablantes
            </strong>
            &nbsp;donde adquieres y desarrollas las competencias necesarias para
            dominar la gestión de un &nbsp;
            <strong className="text-gray-900">Product Backlog</strong>.
          </p>
        }
        heroImage="v1705344536/personas/twyy7ze6bqo0gipfjoyn.png"
        heroImageAlt="Official Product Backlog Management Training"
        heroCTANormalClasses="bg-teal-600"
        heroCTAHoverClasses="hover:bg-teal-700"
        heroCTAFocusClasses="focus:bg-teal-700 focus:ring-teal-600 focus:ring-opacity-20"
        heroHighlighColor="text-teal-600"
        heroBackgroundFrom="from-teal-100"
        heroBackgroundTo="to-white"
        stripesBackgroundFrom="from-teal-500"
        stripesBackgroundTo="to-transparent"
        stripesBackgroundDarkerFrom="from-teal-600"
        stripesBackgroundDarkerTo="to-transparent"
        {...training.details}
      />
      <MarketingHighlightCopy>
        <p className="leading-relaxed">
          El programa&nbsp;
          <strong className="font-semibold text-white">
            Product Backlog Management
          </strong>
          &nbsp;te capacita de manera práctica para la gestión de un&nbsp;
          <strong className="font-semibold text-white">Product Backlog</strong>
          &nbsp;eficiente que te permita liderar problemas complejos entregando
          valor.
        </p>
      </MarketingHighlightCopy>
      {hasContent && <MarketingContent content={training.content} />}
      {hasTrainers && (
        <MarketingTrainers trainers={training.details.trainers} />
      )}
      {hasWhatIsLearned && (
        <MarketingFeatures features={training.details.whatIsLearned} />
      )}
      {hasProgramSubjects && (
        <MarketingProgramSimple program={training.details.programSubjects} />
      )}
      {hasTestimonials && (
        <MarketingTestimonials testimonials={training.details.testimonials} />
      )}
      {hasFAQs && <MarketingFAQs faqs={training.details.faqs} />}
      <MarketingContact />
    </MarketingPageWrapper>
  );
}
